var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(s){return _c('el-tag',{key:s.skill_id,staticClass:"mr-2 mt-2",attrs:{"type":"info","size":"small"},domProps:{"textContent":_vm._s(s.skill_name ? s.skill_name : s.skill.skill_name)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }